module.exports = __webpack_public_path__ + "img/icon_tap_07.dc88dfeb.svg";